import settings from '@/settings'

export default settings.apiURL



// WEBPACK FOOTER //
// ./src/api/url.js